export function buildAddressString(addressItem, includeAllFields) {
    var array = [
        addressItem.organizationName,
        addressItem.firstName,
        addressItem.lastName,
        addressItem.postalCode,
        addressItem.country,
        addressItem.city,
        addressItem.addressLine1,
        addressItem.addressLine2,
        addressItem.phoneNumber,
        addressItem.email,
        addressItem.description,
        addressItem.additionalInfo
    ].filter(function (a) { return a; });
    if (!includeAllFields && array.length > 5) {
        array.splice(5);
        return array.join(', ') + '...';
    }
    else {
        return array.join(', ');
    }
}
